// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"142c7257","656":"9d3f3bed","901":"c72ea877","957":"3b96897d"}[chunkId] + ".chunk.js";
};